import React, { useState, useEffect, useRef } from "react";
import { IoDocumentsOutline } from "react-icons/io5";
import { BsThreeDotsVertical } from "react-icons/bs";
import { LiaEditSolid } from "react-icons/lia";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchMyProjects } from "../../redux/actions/myProjectAction";
import { leftProject } from "../../redux/actions/leftProjectAction";
import { toast } from "react-toastify";

const Projects = ({ page, hesabimUserData, hesabimUserId }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { myProjects, loading } = useSelector((state) => state.myProjects);
  const { success: leftProjectSuccess } = useSelector(
    (state) => state.leftProject
  );
  const [openMenus, setOpenMenus] = useState({});
  const menuRefs = useRef([]);

  // Eğer hesabim sayfasındaysak auth'dan userId'yi al, değilse location state'ten al
  const userId = page === "hesabim" ? hesabimUserId : location.state?.userId;
console.log(myProjects, "myProjects");

  useEffect(() => {
    if (userId) {
      dispatch(fetchMyProjects(userId));
    }
  }, [dispatch, userId, leftProjectSuccess]);

  const toggleMenu = (index) => {
    setOpenMenus((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!menuRefs.current.some((ref) => ref && ref.contains(event.target))) {
        setOpenMenus({});
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
 /*  console.log(myProjects, "myProjects"); */
  return (
    <div className="detay-container">
      <div
        className={`flex items-center text-dark text-lg tracking-wide font-medium ${
          page === "hesabim" ? "flex-row-reverse justify-between" : "flex gap-3"
        }`}
      >
        <span>
          {page === "hesabim" ? (
            <LiaEditSolid className="hidden" />
          ) : (
            <IoDocumentsOutline className="text-dark" />
          )}
        </span>
        <span>Yer Aldığı Projeler</span>
      </div>
      <div className="text-grayy text-sm pt-4">
        <ul className="list-disc ml-4">
          {loading ? (
            <p>Yükleniyor...</p>
          ) : myProjects.length === 0 ? (
            <p>
              {page === "hesabim"
                ? "Henüz bir projeye katılmadınız"
                : "Kullanıcı bir projeye katılmadı."}
            </p>
          ) : (
            myProjects.map((project, index) => {
              return (
                <div key={index} className="my-2 flex justify-between">
                  <li>
                    {project.title} ({project.duration})
                  </li>
                  <div className={page === "hesabim" ? "block" : "hidden"}>
                    {project.status === "Ongoing" && (
                      <div className="relative">
                        <div ref={(el) => (menuRefs.current[index] = el)}>
                          <div onClick={() => toggleMenu(index)}>
                            <BsThreeDotsVertical className="text-grayy cursor-pointer" />
                          </div>
                          <div
                            className={`flex flex-col text-gray text-sm absolute border-2 p-2 gap-2 rounded-xl top-1 right-2 w-[94px] font-medium bg-white ${
                              openMenus[index] ? "block" : "hidden"
                            }`}
                          >
                            <Link
                              to={`/projeler/edit/${project.id}`}
                              state={{ projectId: project.id }}
                              className={`${
                                hesabimUserData?.position?.name === "Project Manager"
                                  ? ""
                                  : "pointer-events-none opacity-50"
                              }`}
                            >
                              <span>Düzenle</span>
                            </Link>
                            <span
                              className="cursor-pointer"
                              onClick={async () => {
                                try {
                                  await dispatch(
                                    leftProject(project.id)
                                  ).unwrap();
                                  toast.success(
                                    "Projeden başarıyla ayrıldınız",
                                    {
                                      position: "top-right",
                                      autoClose: 3000,
                                      hideProgressBar: false,
                                      closeOnClick: true,
                                      pauseOnHover: true,
                                      draggable: true,
                                    }
                                  );
                                } catch (error) {
                                  toast.error(
                                    error ||
                                      "Projeden ayrılırken bir hata oluştu",
                                    {
                                      position: "top-right",
                                      autoClose: 3000,
                                      hideProgressBar: false,
                                      closeOnClick: true,
                                      pauseOnHover: true,
                                      draggable: true,
                                    }
                                  );
                                }
                                setOpenMenus({});
                              }}
                            >
                              Ayrıl
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </ul>
      </div>
    </div>
  );
};

export default React.memo(Projects);
